import { createFileRoute } from '@tanstack/react-router';
import { FinanceiroLancamentosShell } from '@/components/financeiro/FinanceiroLancamentosShell';

export const Route = createFileRoute('/w/$workspaceId/financeiro/contas-pagar')({
  component: ContasPagarPage,
});

function ContasPagarPage() {
  const { workspaceId } = Route.useParams();
  return <FinanceiroLancamentosShell workspaceId={workspaceId} tipo="SAIDA" />;
}
